<!--
    Styles
-->

<style scoped>


    /* main */

    .search {
        position: relative;
    }


    /* input */

    .search .input {
        height: 34px;
    }
    .search .input .ui-spinner {
        width: 20px;
        height: 20px;
        margin-left: 6px;
    }
    .search .input svg.close {
        cursor: pointer;
    }


    /* dropdown */

    .search .dropdown {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
    }


</style>



<!--
    Template
-->

<template>
    <div class="search">


        <!-- input -->

        <ui-search class="input" :class="{focus}" v-focus="focus" v-model="input" :disabled="converting">
            <icon-close class="close cl-blue" v-show="input && !loading" @click="clear()" @mousedown.prevent />
            <ui-spinner class="cl-blue" v-show="loading" />
        </ui-search>


        <!-- suggestions -->

        <div class="dropdown" v-show="focus && suggestions.length">
            <a class="option u-cut" v-for="location in suggestions" :key="location.place_id" @click="select(location)" @mousedown.prevent>
                <span class="w5">{{ location.structured_formatting.main_text }}</span>
                <span class="t12 cl-gray">{{ location.structured_formatting.secondary_text }}</span>
            </a>
        </div>


    </div>
</template>



<!--
    Scripts
-->

<script>


    import maps from '@/common/modules/maps'
    import focus from '@/common/directives/focus'
    import uiSearch from '@/components/shared/ui/search.vue'
    import uiSpinner from '@/components/shared/ui/spinner.vue'
    import iconClose from '@/assets/icons/close.svg'


    export default {

        components: {
            iconClose,
            uiSearch,
            uiSpinner
        },

        directives: {
            focus
        },

        data () {

            return {
                input: null,
                focus: false,
                suggestions: [],
                suggesting: false,
                converting: false
            }
        },

        computed: {

            loading () {
                return this.suggesting || this.converting;
            }

        },

        methods: {

            async select (location) {
                this.focus = false;
                await this.$nextTick();
                this.input = location.structured_formatting.main_text;
                this.converting = maps.places.getLocation(location.place_id);
                this.converting.then(location => {
                    this.converting = false;
                    this.$router.push({
                        name: this.$route.name,
                        query: {...this.$route.query, ...location, zoom: 15}
                    });
                });
            },

            clear () {
                this.suggestions = [];
                this.input = null;
                this.focus = true;
            }

        },

        watch: {

            input (input) {
                maps.places.cancel(this.suggesting);
                if (!input) return (this.suggestions = []);
                this.suggesting = maps.places.suggest(input);
                this.suggesting.then(suggestions => {
                    this.suggesting = false;
                    this.suggestions = suggestions;
                });
            }

        }

    }

</script>

